import { experiment } from "@faire/web--source/common/settings/declarations/experiment";

/**
 * XP to test heavy gate for SEO Discover
 */
export const FE_SEO_DISCOVER_HEAVY_GATING_042425 = experiment({
  name: "FE_SEO_DISCOVER_HEAVY_GATING_042425",
  identifier: "SessionToken",
  client: ["RETAILER", "VISITOR_PERF_APP_WEB"],
  notifyAfter: "2025-05-31",
  defaultValue: false,
  productArea: "LOGGED_OUT_RETAILERS",
});
